import {
  FilingType,
  FinanceType,
  ModalCreateType,
  PP30FilingRoundType,
  PP30FormStatus,
  PP30FormTableSortColumnType,
  PP30FormTableViewStatusType,
  PP30TaxCreditType,
  PP30TaxRefundType,
  SourceType,
  TaxInvoiceType,
  TransactionErrorCode,
  TransactionStatus,
  TransactionTableSortColumnType,
  TransactionTableViewStatusType,
  VerifyType,
} from "@/enums/enums";
import { i18n } from "@/i18n";
import { NewObject } from "./shareHelper";

export function GetPP30CreateTemplate() {
  const pp30FormCreateTemplate: any = {
    id: 0,
    status: 0,
    pp30FormNumber: "",
    isUpdateTableSaleTransaction: false,
    isUpdateTablePurchaseTransaction: false,
    isVerifiedSaleTransaction: false,
    isVerifiedPurchaseTransaction: false,
    isSkipValidateSaleTransaction: false,
    isSkipValidatePurchaseTransaction: false,
    taxPeriodDate: {
      value: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      validateError: false,
    },
    filingType: {
      value: {
        value: FilingType.Normal,
        name: "",
      },
      validateError: false,
    },
    times: {
      value: {
        value: 0,
      },
      validateError: false,
    },
    filingRoundType: {
      value: {
        value: PP30FilingRoundType.None,
      },
      validateError: false,
    },
    saleTransaction: [],
    purchaseTransaction: [],
    pp30TaxCreditType: PP30TaxCreditType.None,
    pp30TaxRefundType: PP30TaxRefundType.None,
    merchant: {
      merchantId: 0,
      merchantName: "",
      merchantTaxId: "",
      merchantBranchCode: "",
      building: "",
      roomNo: "",
      floorNo: "",
      homeGroup: "",
      no: "",
      homeno: "",
      soi: "",
      road: "",
      district1: "",
      district2: "",
      province: "",
      postCode: "",
      phone: "",
    },
    vatZeroSaleAmount: 0, //2 (Sum 0% vat from financetype 1)
    vatExcemptedSaleAmount: 0, //3 (Sum no vat from financetype 1)
    vatApplicableSaleAmount: 0, //4 (Sum 7% from financetype 1)
    salesTaxAmount: 0, //5  (Sum vatTotal from financetype 1)
    vatZeroPurchaseAmount: 0, //na  (Sum 0% vat from financetype 2)
    vatExcemptedPurchaseAmount: 0, //na  (Sum no vat from financetype 2)
    vatClaimablePurchaseAmount: 0, //na  (Sum 7% from financetype 2)
    purchaseTaxAmount: 0, //7   (Sum vatTotal from financetype 2)
    saleTotal: 0, //1   (Sum 0% vat,no vat, 7% from financetype 1)
    purchaseTotal: 0, //6   (Sum 7% from financetype 2)
    countSaleTransaction: 0, //(count from financetype 1)
    countPurchaseTransaction: 0, //(count from financetype 2)
    netTaxAmount: 0, //na (5 - 7) (if > 0 ? 8 : 9)
    vatToPayTotalThisMonth: 0, // 8
    vatToRefundTotalThisMonth: 0, // 9
    changeTaxCreditAmount: 0, //10
    vatToPayTotal: 0, //11 (8 > 10 ? 8 - 10 : null) => (8 - (9 + 10)) >= 0
    vatToRefundTotal: 0, //12 (10 > 8 ? 10 - 8 || 9 > 10 ? 9 + 10) => (8 - (9 + 10)) < 0
    remainingTaxCreditAmount: 0, //na 10 + ((creditTax == true) ? 9 ) - 8  - 13 - 14
    interestAmount: 0, //13
    fineAmount: 0, //14
    taxTotal: 0, //15
    taxTotalOverpaid: 0, //16
  };

  return pp30FormCreateTemplate;
}

export function GetCreatePP30TransactionTemplate(financeType: FinanceType) {
  const pp30TransactionTemplate = {
    financeType: financeType,
    taxInvoiceType: TaxInvoiceType.TaxInvoice,
    contact: {
      value: { id: 0 },
      validateError: false,
    },
    taxInvoiceDate: {
      value: new Date(),
      validateError: false,
    },
    taxInvoiceNumber: {
      value: "",
      validateError: false,
    },
    vatExemptedTotal: {
      value: "0.00",
      validateError: false,
    },
    zeroVatTotal: {
      value: "0.00",
      validateError: false,
    },
    preVatTotal: {
      value: "0.00",
      validateError: false,
    },
    vatTotal: {
      value: "0.00",
      validateError: false,
    },
    taxPeriod: {
      value: financeType == FinanceType.InFlow ? new Date() : "",
      validateError: false,
    },
    reference: {
      value: "",
      validateError: false,
    },
    note: {
      value: "",
      validateError: false,
    },
    createType: ModalCreateType.Basic,
  };

  return pp30TransactionTemplate;
}

export function GetEditPP30TransactionTemplate(pp30Transaction: any) {
  const pp30TransactionTemplate = {
    id: pp30Transaction.id,
    financeType: pp30Transaction.financeType,
    taxInvoiceType: pp30Transaction.taxInvoiceType,
    contact: {
      value: {
        id: 0,
      },
      validateError: false,
    },
    taxInvoiceDate: {
      value: new Date(pp30Transaction.taxInvoiceDate),
      validateError: false,
    },
    taxInvoiceNumber: {
      value: pp30Transaction.taxInvoiceNumber,
      validateError: false,
    },
    vatExemptedTotal: {
      value: pp30Transaction.vatExemptedTotal.FormatMoney(),
      validateError: false,
    },
    zeroVatTotal: {
      value: pp30Transaction.zeroVatTotal.FormatMoney(),
      validateError: false,
    },
    preVatTotal: {
      value: pp30Transaction.preVatTotal.FormatMoney(),
      validateError: false,
    },
    vatTotal: {
      value: pp30Transaction.vatTotal.FormatMoney(),
      validateError: false,
    },
    reference: {
      value: pp30Transaction.reference,
      validateError: false,
    },
    note: {
      value: pp30Transaction.note,
      validateError: false,
    },
    taxPeriod: {
      value: pp30Transaction.taxPeriod,
      validateError: false,
    },
    sourceType: pp30Transaction.sourceType,
    sourceId: pp30Transaction.sourceId,
    createType: ModalCreateType.Advance,
  };
  return pp30TransactionTemplate;
}

export function ValidateCreatePP30Transaction(createPP30Transaction: any) {
  let validated = true;

  if (createPP30Transaction.contact.value && createPP30Transaction.contact.value.id > 0) {
    createPP30Transaction.contact.validateError = false;
  } else {
    createPP30Transaction.contact.validateError = true;
    validated = false;
  }

  if (createPP30Transaction.taxInvoiceDate.value) {
    createPP30Transaction.taxInvoiceDate.validateError = false;
  } else {
    createPP30Transaction.taxInvoiceDate.validateError = true;
    validated = false;
  }

  if (
    createPP30Transaction.taxInvoiceNumber.value &&
    createPP30Transaction.taxInvoiceNumber.value.toString().length > 0
  ) {
    createPP30Transaction.taxInvoiceNumber.validateError = false;
  } else {
    createPP30Transaction.taxInvoiceNumber.validateError = true;
    validated = false;
  }

  if (createPP30Transaction.taxInvoiceType !== TaxInvoiceType.CreditNote) {
    if (createPP30Transaction.vatExemptedTotal.value.ToNumber() >= 0) {
      createPP30Transaction.vatExemptedTotal.validateError = false;
    } else {
      createPP30Transaction.vatExemptedTotal.validateError = true;
      validated = false;
    }
    if (createPP30Transaction.zeroVatTotal.value.ToNumber() >= 0) {
      createPP30Transaction.zeroVatTotal.validateError = false;
    } else {
      createPP30Transaction.zeroVatTotal.validateError = true;
      validated = false;
    }
    if (createPP30Transaction.preVatTotal.value.ToNumber() >= 0) {
      createPP30Transaction.preVatTotal.validateError = false;
    } else {
      createPP30Transaction.preVatTotal.validateError = true;
      validated = false;
    }
    if (createPP30Transaction.vatTotal.value.ToNumber() >= 0) {
      createPP30Transaction.vatTotal.validateError = false;
    } else {
      createPP30Transaction.vatTotal.validateError = true;
      validated = false;
    }
  }

  return validated;
}

export function SetInputErrorPP30TransactionByErrorCode(pp30TransactionTemplate: any, errorCode: TransactionErrorCode) {
  switch (errorCode) {
    case TransactionErrorCode.DuplicateNumber:
      pp30TransactionTemplate.taxInvoiceNumber.validateError = true;
      break;
  }
}

export function SetHeaderSalesPP30TransactionTable() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Tax_Invoice_No",
      sortBy: TransactionTableSortColumnType.TaxInvoiceNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Date",
      sortBy: TransactionTableSortColumnType.TaxInvoiceDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Contact",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Reference_Doc",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Pre_VAT_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "VAT_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "Status",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}
export function SetHeaderPurchasePP30TransactionTable() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Tax_Invoice_No",
      sortBy: TransactionTableSortColumnType.TaxInvoiceNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Date",
      sortBy: TransactionTableSortColumnType.TaxInvoiceDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Contact",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Reference_Doc",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Pre_VAT_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "VAT_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "Status",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}
export function SetTapsPP30TransactionTable(tableView: TransactionTableViewStatusType, countTable: any) {
  const taps = [
    {
      name: "Table_Tap_All",
      length: countTable.allCount,
      bgLengthColor: "blue",
      showtableCount: false,
      tableViewStatusType: TransactionTableViewStatusType.All,
      active: true,
    },
    {
      name: "Table_Tap_AwaitFiling",
      length: countTable.awaitFilingCount,
      bgLengthColor: "blue",
      showtableCount: true,
      tableViewStatusType: TransactionTableViewStatusType.AwaitFiling,
      active: false,
    },
    {
      name: "Table_Tap_FiledTax",
      length: countTable.filedTaxCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: TransactionTableViewStatusType.FiledTax,
      active: false,
    },
    {
      name: "Table_Tap_Void",
      length: countTable.voidedCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: TransactionTableViewStatusType.Voided,
      active: false,
    },
  ];

  return taps;
}
export function SetTapsPP30Form(tableView: PP30FormTableViewStatusType, countTable: any) {
  const taps = [
    {
      name: "Table_Tap_All",
      length: countTable,
      bgLengthColor: "blue",
      showtableCount: false,
      tableViewStatusType: PP30FormTableViewStatusType.All,
      active: true,
    },
    {
      name: "Table_Tap_Draft",
      length: countTable,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: PP30FormTableViewStatusType.Draft,
      active: false,
    },
    {
      name: "Table_Tap_AwaitApprove",
      length: countTable,
      bgLengthColor: "blue",
      showtableCount: false,
      tableViewStatusType: PP30FormTableViewStatusType.AwaitApproval,
      active: false,
    },
    {
      name: "Table_Tap_AwaitFiling",
      length: countTable,
      bgLengthColor: "orange",
      showtableCount: false,
      tableViewStatusType: PP30FormTableViewStatusType.AwaitFiling,
      active: false,
    },
    {
      name: "Table_Tap_AwaitPayment",
      length: countTable,
      bgLengthColor: "orange",
      showtableCount: false,
      tableViewStatusType: PP30FormTableViewStatusType.AwaitPayment,
      active: false,
    },
    {
      name: "Table_Tap_TaxPaid",
      length: countTable,
      bgLengthColor: "blue",
      showtableCount: false,
      tableViewStatusType: PP30FormTableViewStatusType.Paid,
      active: false,
    },
    {
      name: "Table_Tap_Void",
      length: countTable,
      bgLengthColor: "blue",
      showtableCount: false,
      tableViewStatusType: PP30FormTableViewStatusType.Voided,
      active: false,
    },
  ];

  return taps;
}
export function SetHeaderPP30Form() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Number_Form",
      sortBy: PP30FormTableSortColumnType.PP30FormNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Tax_Period",
      sortBy: PP30FormTableSortColumnType.PP30FormDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Sales_Tax",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Purchase_Tax",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Tax_Payable",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Balance_Tax_Credit",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Status",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
      isSetPadding: true,
    },
  ];
  return header;
}
export function ConvertToPP30TransactionTableByPeriodTax(pp30TransactionTableByPeriodTax: any, check: boolean) {
  const pp30FormDetail = {
    saleTransaction: {
      count: 0,
      detailList: [] as any,
    },
    purchaseTransaction: {
      count: 0,
      detailList: [] as any,
    },
  };

  if (pp30TransactionTableByPeriodTax) {
    if (pp30TransactionTableByPeriodTax.saleTransaction && pp30TransactionTableByPeriodTax.saleTransaction.length > 0) {
      pp30FormDetail.saleTransaction.count = pp30TransactionTableByPeriodTax.saleTransaction.length;
      pp30TransactionTableByPeriodTax.saleTransaction.forEach((pp30Transaction: any) => {
        const data = {
          contactId: pp30Transaction.contactId,
          financeType: pp30Transaction.financeType,
          id: pp30Transaction.id,
          netTotal: pp30Transaction.netTotal,
          preVatTotal: pp30Transaction.preVatTotal,
          reference: pp30Transaction.reference,
          sourceId: pp30Transaction.sourceId,
          sourceType: pp30Transaction.sourceType,
          subTotal: pp30Transaction.subTotal,
          taxInvoiceDate: pp30Transaction.taxInvoiceDate,
          taxInvoiceNumber: pp30Transaction.taxInvoiceNumber,
          taxInvoiceType: pp30Transaction.taxInvoiceType,
          vatExemptedTotal: pp30Transaction.vatExemptedTotal,
          vatTotal: pp30Transaction.vatTotal,
          zeroVatTotal: pp30Transaction.zeroVatTotal,
          disabled: false,
          check: check,
          referenceTransactionId: 0,
          referenceTransactionType: 0,
          transactionItemType: 0,
          taxPeriod: pp30Transaction.taxPeriod,
        };
        pp30FormDetail.saleTransaction.detailList.push(data);
      });
    }

    if (
      pp30TransactionTableByPeriodTax.purchaseTransaction &&
      pp30TransactionTableByPeriodTax.purchaseTransaction.length > 0
    ) {
      pp30FormDetail.purchaseTransaction.count = pp30TransactionTableByPeriodTax.purchaseTransaction.length;
      pp30TransactionTableByPeriodTax.purchaseTransaction.forEach((pp30Transaction: any) => {
        const data = {
          contactId: pp30Transaction.contactId,
          financeType: pp30Transaction.financeType,
          id: pp30Transaction.id,
          netTotal: pp30Transaction.netTotal,
          preVatTotal: pp30Transaction.preVatTotal,
          reference: pp30Transaction.reference,
          sourceId: pp30Transaction.sourceId,
          sourceType: pp30Transaction.sourceType,
          subTotal: pp30Transaction.subTotal,
          taxInvoiceDate: pp30Transaction.taxInvoiceDate,
          taxInvoiceNumber: pp30Transaction.taxInvoiceNumber,
          taxInvoiceType: pp30Transaction.taxInvoiceType,
          vatExemptedTotal: pp30Transaction.vatExemptedTotal,
          vatTotal: pp30Transaction.vatTotal,
          zeroVatTotal: pp30Transaction.zeroVatTotal,
          disabled: pp30Transaction.taxInvoiceType == TaxInvoiceType.NonTaxInvoice,
          check: check ? pp30Transaction.taxInvoiceType != TaxInvoiceType.NonTaxInvoice : false,
          referenceTransactionId: 0,
          referenceTransactionType: 0,
          transactionItemType: 0,
          taxPeriod: pp30Transaction.taxPeriod,
        };
        pp30FormDetail.purchaseTransaction.detailList.push(data);
      });
    }
  }
  return pp30FormDetail;
}
function GetTaxInvoiceTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    filterETaxInvoiceType: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
export function GetTaxInvoiceTableCountRequest(input: any) {
  const data = {
    tableStatus: 4,
    fromDate: input.fromDate,
    toDate: input.toDate,
    searchText: "",
    isUseMainDatabase: false,
    filterETaxInvoiceType: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
  return data;
}
export function GetTaxInvoiceTableRequest(input: any, pageSize: any) {
  const data = {
    tableStatus: 4,
    fromDate: input.fromDate,
    toDate: input.toDate,
    searchText: "",
    tableSorting: 0,
    transactionTableView: 1,
    pageNo: 1,
    pageSize: pageSize,
    isUseMainDatabase: false,
    filterETaxInvoiceType: input.filterETaxInvoiceType,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
  return data;
}
export function ConvertToPP30TransactionFromPeakAccount(pp30TransactionData: any) {
  const pp30FormDetail = {
    pp30Transaction: {
      count: 0,
      detailList: [] as any,
    },
  };
  if (pp30TransactionData) {
    pp30FormDetail.pp30Transaction.count = pp30TransactionData.length;
    pp30TransactionData.forEach((pp30Transaction: any) => {
      const data = {
        contactId: pp30Transaction.contactId,
        financeType: 2,
        id: 0,
        netTotal: pp30Transaction.netAmount,
        preVatTotal: pp30Transaction.netAmount - pp30Transaction.vatTotal,
        reference: pp30Transaction.number,
        sourceId: pp30Transaction.id,
        sourceType: SourceType.PeakAccount,
        subTotal: pp30Transaction.netAmount - pp30Transaction.vatTotal,
        taxInvoiceDate: pp30Transaction.date,
        taxInvoiceNumber: "",
        taxInvoiceType: TaxInvoiceType.NonTaxInvoice,
        vatExemptedTotal: 0,
        vatTotal: pp30Transaction.vatTotal,
        zeroVatTotal: 0,
        disabled: true,
        check: false,
        referenceTransactionId: pp30Transaction.referenceTransactionId,
        referenceTransactionType: pp30Transaction.referenceTransactionType,
        transactionItemType: pp30Transaction.transactionItemType,
      };

      pp30FormDetail.pp30Transaction.detailList.push(data);
    });
  }
  return pp30FormDetail;
}

export function SetHeadertPP30SaleTransaction(isCheck = false) {
  const header = [
    {
      name: "check",
      hidden: isCheck ? false : true,
      checkAll: false,
    },
    {
      name: "Document_No",
      sortBy: TransactionTableSortColumnType.TaxInvoiceNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Issued_Date",
      sortBy: TransactionTableSortColumnType.TaxInvoiceDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Input_Contact",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Tax_Exempt_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "VAT_0_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "VAT_7_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Tax_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}

export function SetHeadertPP30SaleTransactionForDetail(isCheck = false) {
  const header = [
    {
      name: "check",
      hidden: isCheck ? false : true,
      checkAll: false,
    },
    {
      name: "Tax_No",
      sortBy: TransactionTableSortColumnType.TaxInvoiceNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Date",
      sortBy: TransactionTableSortColumnType.TaxInvoiceDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Input_Contact",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Tax_Exempt_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "VAT_0_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "VAT_7_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "VAT",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}

export function SetHeadertPP30PurchaseTransaction(isCheck = false) {
  const header = [
    {
      name: "check",
      hidden: isCheck ? false : true,
      checkAll: false,
    },
    {
      name: "Document_No",
      sortBy: TransactionTableSortColumnType.TaxInvoiceNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "TaxInvoice_Date",
      sortBy: TransactionTableSortColumnType.TaxInvoiceDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Input_Contact",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Header_Expense_Document",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Text_TransactionAmount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Tax_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}

export function SetHeadertPP30PurchaseTransactionForDetail(isCheck = false) {
  const header = [
    {
      name: "check",
      hidden: isCheck ? false : true,
      checkAll: false,
    },
    {
      name: "Tax_No",
      sortBy: TransactionTableSortColumnType.TaxInvoiceNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Date",
      sortBy: TransactionTableSortColumnType.TaxInvoiceDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Input_Contact",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Reference_Doc",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "VAT_7_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "VAT",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}

export function SetDefaultsValuePP30FormCreateTemplate(pp30FormCreateTemplate: any) {
  pp30FormCreateTemplate.vatZeroSaleAmount = 0;
  pp30FormCreateTemplate.vatExcemptedSaleAmount = 0;
  pp30FormCreateTemplate.vatApplicableSaleAmount = 0;
  pp30FormCreateTemplate.salesTaxAmount = 0;
  pp30FormCreateTemplate.vatZeroPurchaseAmount = 0;
  pp30FormCreateTemplate.vatExcemptedPurchaseAmount = 0;
  pp30FormCreateTemplate.vatClaimablePurchaseAmount = 0;
  pp30FormCreateTemplate.purchaseTaxAmount = 0;
  pp30FormCreateTemplate.saleTotal = 0;
  pp30FormCreateTemplate.purchaseTotal = 0;
  pp30FormCreateTemplate.countSaleTransaction = 0;
  pp30FormCreateTemplate.countPurchaseTransaction = 0;
  pp30FormCreateTemplate.netTaxAmount = 0;
  pp30FormCreateTemplate.vatToPayTotalThisMonth = 0;
  pp30FormCreateTemplate.vatToRefundTotalThisMonth = 0;
  // pp30FormCreateTemplate.changeTaxCreditAmount = 0; //10
  pp30FormCreateTemplate.vatToPayTotal = 0;
  pp30FormCreateTemplate.vatToRefundTotal = 0;
  pp30FormCreateTemplate.remainingTaxCreditAmount = 0;
  // pp30FormCreateTemplate.interestAmount = 0; //13
  // pp30FormCreateTemplate.fineAmount = 0; //14
  pp30FormCreateTemplate.taxTotal = 0; //15
  pp30FormCreateTemplate.taxTotalOverpaid = 0;
}

export function CalculatePP30CreateTemplate(pp30FormCreateTemplate: any) {
  SetDefaultsValuePP30FormCreateTemplate(pp30FormCreateTemplate);
  pp30FormCreateTemplate.saleTransaction.forEach((saleTransaction: any) => {
    pp30FormCreateTemplate.vatZeroSaleAmount += saleTransaction.zeroVatTotal.ToNumber();
    pp30FormCreateTemplate.vatExcemptedSaleAmount += saleTransaction.vatExemptedTotal.ToNumber();
    pp30FormCreateTemplate.vatApplicableSaleAmount += saleTransaction.preVatTotal.ToNumber();
    pp30FormCreateTemplate.salesTaxAmount += saleTransaction.vatTotal.ToNumber();
  });

  pp30FormCreateTemplate.purchaseTransaction.forEach((purchaseTransaction: any) => {
    pp30FormCreateTemplate.vatZeroPurchaseAmount += purchaseTransaction.zeroVatTotal.ToNumber();
    pp30FormCreateTemplate.vatExcemptedPurchaseAmount += purchaseTransaction.vatExemptedTotal.ToNumber();
    pp30FormCreateTemplate.vatClaimablePurchaseAmount += purchaseTransaction.preVatTotal.ToNumber();
    pp30FormCreateTemplate.purchaseTaxAmount += purchaseTransaction.vatTotal.ToNumber();
  });

  pp30FormCreateTemplate.saleTotal =
    pp30FormCreateTemplate.vatZeroSaleAmount.ToNumber() +
    pp30FormCreateTemplate.vatExcemptedSaleAmount.ToNumber() +
    pp30FormCreateTemplate.vatApplicableSaleAmount.ToNumber();

  pp30FormCreateTemplate.purchaseTotal = pp30FormCreateTemplate.vatClaimablePurchaseAmount.ToNumber();

  pp30FormCreateTemplate.countSaleTransaction = pp30FormCreateTemplate.saleTransaction.length;
  pp30FormCreateTemplate.countPurchaseTransaction = pp30FormCreateTemplate.purchaseTransaction.length;

  pp30FormCreateTemplate.netTaxAmount =
    pp30FormCreateTemplate.salesTaxAmount - pp30FormCreateTemplate.purchaseTaxAmount;

  pp30FormCreateTemplate.vatToPayTotalThisMonth =
    pp30FormCreateTemplate.netTaxAmount >= 0 ? pp30FormCreateTemplate.netTaxAmount : 0;

  pp30FormCreateTemplate.vatToRefundTotalThisMonth =
    pp30FormCreateTemplate.netTaxAmount < 0 ? pp30FormCreateTemplate.netTaxAmount * -1 : 0;

  const netVatSummaryAmount =
    pp30FormCreateTemplate.vatToPayTotalThisMonth -
    (pp30FormCreateTemplate.vatToRefundTotalThisMonth + pp30FormCreateTemplate.changeTaxCreditAmount);

  pp30FormCreateTemplate.vatToPayTotal = netVatSummaryAmount >= 0 ? netVatSummaryAmount : 0;
  pp30FormCreateTemplate.vatToRefundTotal = netVatSummaryAmount < 0 ? netVatSummaryAmount * -1 : 0;

  pp30FormCreateTemplate.remainingTaxCreditAmount =
    pp30FormCreateTemplate.changeTaxCreditAmount +
    (pp30FormCreateTemplate.pp30TaxCreditType == PP30TaxCreditType.CreditTax
      ? pp30FormCreateTemplate.vatToRefundTotalThisMonth
      : 0) -
    (pp30FormCreateTemplate.vatToPayTotalThisMonth +
      pp30FormCreateTemplate.interestAmount +
      pp30FormCreateTemplate.fineAmount);

  if (pp30FormCreateTemplate.remainingTaxCreditAmount < 0) {
    pp30FormCreateTemplate.remainingTaxCreditAmount = 0;
  }

  pp30FormCreateTemplate.changeTaxCreditAmount =
    pp30FormCreateTemplate.filingType.value.value == FilingType.More ? 0 : pp30FormCreateTemplate.changeTaxCreditAmount;

  const netAmount = netVatSummaryAmount + pp30FormCreateTemplate.interestAmount + pp30FormCreateTemplate.fineAmount;

  pp30FormCreateTemplate.taxTotal = netAmount >= 0 ? netAmount : 0;

  pp30FormCreateTemplate.taxTotalOverpaid = netAmount < 0 ? netAmount * -1 : 0;
}

export function ConvertToInsertPP30FormModel(pp30FormCreateTemplate: any) {
  const insertPP30FormModel = {
    id: pp30FormCreateTemplate.id,
    status: pp30FormCreateTemplate.status,
    purchaseTransaction: [] as any,
    saleTransaction: [] as any,
    formNumber: pp30FormCreateTemplate.pp30FormNumber,
    formDate: pp30FormCreateTemplate.taxPeriodDate.value.ToDateJsonString(),
    vatZeroSaleAmount: pp30FormCreateTemplate.vatZeroSaleAmount.ToNumber(),
    vatExcemptedSaleAmount: pp30FormCreateTemplate.vatExcemptedSaleAmount.ToNumber(),
    vatApplicableSaleAmount: pp30FormCreateTemplate.vatApplicableSaleAmount.ToNumber(),
    vatZeroPurchaseAmount: pp30FormCreateTemplate.vatZeroPurchaseAmount.ToNumber(),
    vatExcemptedPurchaseAmount: pp30FormCreateTemplate.vatExcemptedPurchaseAmount.ToNumber(),
    vatClaimablePurchaseAmount: pp30FormCreateTemplate.vatClaimablePurchaseAmount.ToNumber(),
    salesTaxAmount: pp30FormCreateTemplate.salesTaxAmount.ToNumber(),
    purchaseTaxAmount: pp30FormCreateTemplate.purchaseTaxAmount.ToNumber(),
    saleTotal: pp30FormCreateTemplate.saleTotal.ToNumber(),
    purchaseTotal: pp30FormCreateTemplate.purchaseTotal.ToNumber(),
    remainingTaxCreditAmount: pp30FormCreateTemplate.remainingTaxCreditAmount.ToNumber(),
    interestAmount: pp30FormCreateTemplate.interestAmount.ToNumber(),
    fineAmount: pp30FormCreateTemplate.fineAmount.ToNumber(),
    vatToPayTotal: pp30FormCreateTemplate.vatToPayTotal.ToNumber(),
    vatToRefundTotal: pp30FormCreateTemplate.vatToRefundTotal.ToNumber(),
    changeTaxCreditAmount: pp30FormCreateTemplate.changeTaxCreditAmount.ToNumber(),
    netTaxAmount: pp30FormCreateTemplate.netTaxAmount.ToNumber(),
    countSaleTransaction: pp30FormCreateTemplate.countSaleTransaction.ToNumber(),
    countPurchaseTransaction: pp30FormCreateTemplate.countPurchaseTransaction.ToNumber(),
    filingType: pp30FormCreateTemplate.filingType.value.value,
    filingRound: pp30FormCreateTemplate.times.value.value,
    filingRoundType: pp30FormCreateTemplate.filingRoundType.value.value,
    taxCreditType: pp30FormCreateTemplate.pp30TaxCreditType,
    taxRefundType: pp30FormCreateTemplate.pp30TaxRefundType,
  };
  for (const transaction of pp30FormCreateTemplate.purchaseTransaction) {
    insertPP30FormModel.purchaseTransaction.push({
      transactionId: transaction.id,
      sourceId: transaction.sourceId,
      sourceType: transaction.sourceType,
    });
  }

  for (const transaction of pp30FormCreateTemplate.saleTransaction) {
    insertPP30FormModel.purchaseTransaction.push({
      transactionId: transaction.id,
      sourceId: transaction.sourceId,
      sourceType: transaction.sourceType,
    });
  }

  return insertPP30FormModel;
}

export function ConvertToPP30FormDetailModel(_pp30FormDetailModel: any, _pp30FormTransaction: any) {
  const pp30FormDetailModel = {
    purchaseTransaction: _pp30FormTransaction.purchaseTransaction,
    saleTransaction: _pp30FormTransaction.saleTransaction,
    id: _pp30FormDetailModel.id,
    merchantId: _pp30FormDetailModel.merchantId,
    createUserId: _pp30FormDetailModel.createUserId,
    createDateTime: _pp30FormDetailModel.createDateTime,
    updateUserId: _pp30FormDetailModel.updateUserId,
    updateDateTime: _pp30FormDetailModel.updateDateTime,
    approveUserId: _pp30FormDetailModel.approveUserId,
    approveDateTime: _pp30FormDetailModel.approveDateTime,
    status: _pp30FormDetailModel.status,
    isFiled: _pp30FormDetailModel.isFiled,
    isClosingEntry: _pp30FormDetailModel.isClosingEntry,
    isPaid: _pp30FormDetailModel.isPaid,
    isGotReceipt: _pp30FormDetailModel.isGotReceipt,
    isDeleted: _pp30FormDetailModel.isDeleted,
    actionGotReceipt: _pp30FormDetailModel.actionGotReceipt,
    formNumber: _pp30FormDetailModel.formNumber,
    formDate: _pp30FormDetailModel.formDate,
    vatZeroSaleAmount: _pp30FormDetailModel.vatZeroSaleAmount,
    vatExcemptedSaleAmount: _pp30FormDetailModel.vatExcemptedSaleAmount,
    vatApplicableSaleAmount: _pp30FormDetailModel.vatApplicableSaleAmount,
    vatZeroPurchaseAmount: _pp30FormDetailModel.vatZeroPurchaseAmount,
    vatExcemptedPurchaseAmount: _pp30FormDetailModel.vatExcemptedPurchaseAmount,
    vatClaimablePurchaseAmount: _pp30FormDetailModel.vatClaimablePurchaseAmount,
    salesTaxAmount: _pp30FormDetailModel.salesTaxAmount,
    purchaseTaxAmount: _pp30FormDetailModel.purchaseTaxAmount,
    saleTotal: _pp30FormDetailModel.saleTotal,
    purchaseTotal: _pp30FormDetailModel.purchaseTotal,
    remainingTaxCreditAmount: _pp30FormDetailModel.remainingTaxCreditAmount,
    interestAmount: _pp30FormDetailModel.interestAmount,
    fineAmount: _pp30FormDetailModel.fineAmount,
    vatToPayTotal: _pp30FormDetailModel.vatToPayTotal,
    vatToRefundTotal: _pp30FormDetailModel.vatToRefundTotal,
    changeTaxCreditAmount: _pp30FormDetailModel.changeTaxCreditAmount,
    netTaxAmount: _pp30FormDetailModel.netTaxAmount,
    countSaleTransaction: _pp30FormDetailModel.countSaleTransaction,
    countPurchaseTransaction: _pp30FormDetailModel.countPurchaseTransaction,
    filingType: _pp30FormDetailModel.filingType,
    filingRound: _pp30FormDetailModel.filingRound,
    filingRoundType: _pp30FormDetailModel.filingRoundType,
    taxCreditType: _pp30FormDetailModel.taxCreditType,
    taxRefundType: _pp30FormDetailModel.taxRefundType,
  };

  return pp30FormDetailModel;
}

export function SetPP30TransactionDetailForEdit(pp30TransactionTableByPeriodTax: any) {
  const pp30FormDetail = {
    saleTransaction: {
      count: 0,
      detailList: [] as any,
    },
    purchaseTransaction: {
      count: 0,
      detailList: [] as any,
    },
  };

  if (pp30TransactionTableByPeriodTax) {
    if (pp30TransactionTableByPeriodTax.saleTransaction && pp30TransactionTableByPeriodTax.saleTransaction.length > 0) {
      pp30FormDetail.saleTransaction.count = pp30TransactionTableByPeriodTax.saleTransaction.length;
      pp30TransactionTableByPeriodTax.saleTransaction.forEach((pp30Transaction: any) => {
        const data = {
          contactId: pp30Transaction.contactId,
          financeType: pp30Transaction.financeType,
          id: pp30Transaction.id,
          netTotal: pp30Transaction.netTotal,
          preVatTotal: pp30Transaction.preVatTotal,
          reference: pp30Transaction.reference,
          sourceId: pp30Transaction.sourceId,
          sourceType: pp30Transaction.sourceType,
          subTotal: pp30Transaction.subTotal,
          taxInvoiceDate: pp30Transaction.taxInvoiceDate,
          taxInvoiceNumber: pp30Transaction.taxInvoiceNumber,
          taxInvoiceType: pp30Transaction.taxInvoiceType,
          vatExemptedTotal: pp30Transaction.vatExemptedTotal,
          vatTotal: pp30Transaction.vatTotal,
          zeroVatTotal: pp30Transaction.zeroVatTotal,
          disabled: false,
          check: true,
          referenceTransactionId: 0,
          referenceTransactionType: 0,
          transactionItemType: 0,
        };
        pp30FormDetail.saleTransaction.detailList.push(data);
      });
    }

    if (
      pp30TransactionTableByPeriodTax.purchaseTransaction &&
      pp30TransactionTableByPeriodTax.purchaseTransaction.length > 0
    ) {
      pp30FormDetail.purchaseTransaction.count = pp30TransactionTableByPeriodTax.purchaseTransaction.length;
      pp30TransactionTableByPeriodTax.purchaseTransaction.forEach((pp30Transaction: any) => {
        const data = {
          contactId: pp30Transaction.contactId,
          financeType: pp30Transaction.financeType,
          id: pp30Transaction.id,
          netTotal: pp30Transaction.netTotal,
          preVatTotal: pp30Transaction.preVatTotal,
          reference: pp30Transaction.reference,
          sourceId: pp30Transaction.sourceId,
          sourceType: pp30Transaction.sourceType,
          subTotal: pp30Transaction.subTotal,
          taxInvoiceDate: pp30Transaction.taxInvoiceDate,
          taxInvoiceNumber: pp30Transaction.taxInvoiceNumber,
          taxInvoiceType: pp30Transaction.taxInvoiceType,
          vatExemptedTotal: pp30Transaction.vatExemptedTotal,
          vatTotal: pp30Transaction.vatTotal,
          zeroVatTotal: pp30Transaction.zeroVatTotal,
          disabled: pp30Transaction.taxInvoiceType == TaxInvoiceType.NonTaxInvoice,
          check: pp30Transaction.taxInvoiceType != TaxInvoiceType.NonTaxInvoice,
          referenceTransactionId: 0,
          referenceTransactionType: 0,
          transactionItemType: 0,
        };
        pp30FormDetail.purchaseTransaction.detailList.push(data);
      });
    }
  }
  return pp30FormDetail;
}

export function SetNewPP30DetailForEdit(pp30FormDetail: any) {
  const pp30CreateTemplate = GetPP30CreateTemplate();
  pp30CreateTemplate.id = pp30FormDetail.id;
  pp30CreateTemplate.status = pp30FormDetail.status;
  pp30CreateTemplate.taxPeriodDate.value = new Date(pp30FormDetail.formDate);
  pp30CreateTemplate.filingType.value.value = pp30FormDetail.filingType;
  pp30CreateTemplate.times.value.value = pp30FormDetail.filingRound;
  pp30CreateTemplate.filingRoundType.value.value = pp30FormDetail.filingRoundType;
  pp30CreateTemplate.pp30FormNumber = pp30FormDetail.formNumber;
  pp30CreateTemplate.pp30TaxCreditType = pp30FormDetail.taxCreditType;
  pp30CreateTemplate.pp30TaxRefundType = pp30FormDetail.taxRefundType;
  pp30CreateTemplate.vatZeroSaleAmount = pp30FormDetail.vatZeroSaleAmount;
  pp30CreateTemplate.vatExcemptedSaleAmount = pp30FormDetail.vatExcemptedSaleAmount;
  pp30CreateTemplate.vatApplicableSaleAmount = pp30FormDetail.vatApplicableSaleAmount;
  pp30CreateTemplate.salesTaxAmount = pp30FormDetail.salesTaxAmount;
  pp30CreateTemplate.vatZeroPurchaseAmount = pp30FormDetail.vatZeroPurchaseAmount;
  pp30CreateTemplate.vatExcemptedPurchaseAmount = pp30FormDetail.vatExcemptedPurchaseAmount;
  pp30CreateTemplate.vatClaimablePurchaseAmount = pp30FormDetail.vatClaimablePurchaseAmount;
  pp30CreateTemplate.purchaseTaxAmount = pp30FormDetail.purchaseTaxAmount;
  pp30CreateTemplate.saleTotal = pp30FormDetail.saleTotal;
  pp30CreateTemplate.purchaseTotal = pp30FormDetail.purchaseTotal;
  pp30CreateTemplate.countSaleTransaction = pp30FormDetail.countSaleTransaction;
  pp30CreateTemplate.countPurchaseTransaction = pp30FormDetail.countPurchaseTransaction;
  pp30CreateTemplate.netTaxAmount = pp30FormDetail.netTaxAmount;
  pp30CreateTemplate.changeTaxCreditAmount = pp30FormDetail.changeTaxCreditAmount;
  pp30CreateTemplate.vatToPayTotal = pp30FormDetail.vatToPayTotal;
  pp30CreateTemplate.vatToRefundTotal = pp30FormDetail.vatToRefundTotal;
  pp30CreateTemplate.remainingTaxCreditAmount = pp30FormDetail.remainingTaxCreditAmount;
  pp30CreateTemplate.interestAmount = pp30FormDetail.interestAmount;
  pp30CreateTemplate.fineAmount = pp30FormDetail.fineAmount;

  if (pp30FormDetail.saleTransaction && pp30FormDetail.saleTransaction.length > 0) {
    pp30FormDetail.saleTransaction.forEach((pp30Transaction: any) => {
      const data = {
        contactId: pp30Transaction.contactId,
        financeType: pp30Transaction.financeType,
        id: pp30Transaction.id,
        netTotal: pp30Transaction.netTotal,
        preVatTotal: pp30Transaction.preVatTotal,
        reference: pp30Transaction.reference,
        sourceId: pp30Transaction.sourceId,
        sourceType: pp30Transaction.sourceType,
        subTotal: pp30Transaction.subTotal,
        taxInvoiceDate: pp30Transaction.taxInvoiceDate,
        taxInvoiceNumber: pp30Transaction.taxInvoiceNumber,
        taxInvoiceType: pp30Transaction.taxInvoiceType,
        vatExemptedTotal: pp30Transaction.vatExemptedTotal,
        vatTotal: pp30Transaction.vatTotal,
        zeroVatTotal: pp30Transaction.zeroVatTotal,
        disabled: false,
        check: true,
        referenceTransactionId: 0,
        referenceTransactionType: 0,
        transactionItemType: 0,
      };
      pp30CreateTemplate.saleTransaction.push(data);
    });
  }

  if (pp30FormDetail.purchaseTransaction && pp30FormDetail.purchaseTransaction.length > 0) {
    pp30FormDetail.purchaseTransaction.forEach((pp30Transaction: any) => {
      const data = {
        contactId: pp30Transaction.contactId,
        financeType: pp30Transaction.financeType,
        id: pp30Transaction.id,
        netTotal: pp30Transaction.netTotal,
        preVatTotal: pp30Transaction.preVatTotal,
        reference: pp30Transaction.reference,
        sourceId: pp30Transaction.sourceId,
        sourceType: pp30Transaction.sourceType,
        subTotal: pp30Transaction.subTotal,
        taxInvoiceDate: pp30Transaction.taxInvoiceDate,
        taxInvoiceNumber: pp30Transaction.taxInvoiceNumber,
        taxInvoiceType: pp30Transaction.taxInvoiceType,
        vatExemptedTotal: pp30Transaction.vatExemptedTotal,
        vatTotal: pp30Transaction.vatTotal,
        zeroVatTotal: pp30Transaction.zeroVatTotal,
        disabled: pp30Transaction.taxInvoiceType == TaxInvoiceType.NonTaxInvoice,
        check: pp30Transaction.taxInvoiceType != TaxInvoiceType.NonTaxInvoice,
        referenceTransactionId: 0,
        referenceTransactionType: 0,
        transactionItemType: 0,
      };
      pp30CreateTemplate.purchaseTransaction.push(data);
    });
  }
  return pp30CreateTemplate;
}

export function SetPP30DetailForEdit(pp30FormDetail: any) {
  const pp30CreateTemplate = GetPP30CreateTemplate();
  pp30CreateTemplate.id = pp30FormDetail.id;
  pp30CreateTemplate.status = pp30FormDetail.status;
  pp30CreateTemplate.taxPeriodDate.value = new Date(pp30FormDetail.formDate);
  pp30CreateTemplate.filingType.value.value = pp30FormDetail.filingType;
  pp30CreateTemplate.times.value.value = pp30FormDetail.filingRound;
  pp30CreateTemplate.filingRoundType.value.value = pp30FormDetail.filingRoundType;
  pp30CreateTemplate.pp30FormNumber = pp30FormDetail.formNumber;
  pp30CreateTemplate.pp30TaxCreditType = pp30FormDetail.taxCreditType;
  pp30CreateTemplate.pp30TaxRefundType = pp30FormDetail.taxRefundType;
  pp30CreateTemplate.saleTransaction = pp30FormDetail.saleTransaction;
  pp30CreateTemplate.purchaseTransaction = pp30FormDetail.purchaseTransaction;
  pp30CreateTemplate.vatZeroSaleAmount = pp30FormDetail.vatZeroSaleAmount;
  pp30CreateTemplate.vatExcemptedSaleAmount = pp30FormDetail.vatExcemptedSaleAmount;
  pp30CreateTemplate.vatApplicableSaleAmount = pp30FormDetail.vatApplicableSaleAmount;
  pp30CreateTemplate.salesTaxAmount = pp30FormDetail.salesTaxAmount;
  pp30CreateTemplate.vatZeroPurchaseAmount = pp30FormDetail.vatZeroPurchaseAmount;
  pp30CreateTemplate.vatExcemptedPurchaseAmount = pp30FormDetail.vatExcemptedPurchaseAmount;
  pp30CreateTemplate.vatClaimablePurchaseAmount = pp30FormDetail.vatClaimablePurchaseAmount;
  pp30CreateTemplate.purchaseTaxAmount = pp30FormDetail.purchaseTaxAmount;
  pp30CreateTemplate.saleTotal = pp30FormDetail.saleTotal;
  pp30CreateTemplate.purchaseTotal = pp30FormDetail.purchaseTotal;
  pp30CreateTemplate.countSaleTransaction = pp30FormDetail.countSaleTransaction;
  pp30CreateTemplate.countPurchaseTransaction = pp30FormDetail.countPurchaseTransaction;
  pp30CreateTemplate.netTaxAmount = pp30FormDetail.netTaxAmount;
  pp30CreateTemplate.changeTaxCreditAmount = pp30FormDetail.changeTaxCreditAmount;
  pp30CreateTemplate.vatToPayTotal = pp30FormDetail.vatToPayTotal;
  pp30CreateTemplate.vatToRefundTotal = pp30FormDetail.vatToRefundTotal;
  pp30CreateTemplate.remainingTaxCreditAmount = pp30FormDetail.remainingTaxCreditAmount;
  pp30CreateTemplate.interestAmount = pp30FormDetail.interestAmount;
  pp30CreateTemplate.fineAmount = pp30FormDetail.fineAmount;

  return pp30CreateTemplate;
}

export function ComparetaxInvoiceDetailForPP30(transaction: any, taxInvoice: any) {
  let netTotal = transaction.netTotal;
  let vatExemptedTotal = transaction.vatExemptedTotal;
  let zeroVatTotal = transaction.zeroVatTotal;
  let preVatTotal = transaction.preVatTotal;
  let vatTotal = transaction.vatTotal;

  if (transaction.taxInvoiceType === TaxInvoiceType.CreditNote) {
    netTotal = netTotal * -1;
    vatExemptedTotal = vatExemptedTotal * -1;
    zeroVatTotal = zeroVatTotal * -1;
    preVatTotal = preVatTotal * -1;
    vatTotal = vatTotal * -1;
  }

  const isDeleted = taxInvoice.isDeleted;
  const validateDate = transaction.taxInvoiceDate.ToDateJsonString() == taxInvoice.date.ToDateJsonString();
  const validateNumber = transaction.taxInvoiceNumber == taxInvoice.number;

  const validatNetAmount = netTotal.FormatMoney().ToNumber() == taxInvoice.netAmount.FormatMoney().ToNumber();
  const validatePreVatTotal = preVatTotal.FormatMoney().ToNumber() == taxInvoice.preVatTotal.FormatMoney().ToNumber();
  const validateVatExemptedTotal =
    vatExemptedTotal.FormatMoney().ToNumber() == taxInvoice.vatExemptedTotal.FormatMoney().ToNumber();
  const validateVatTotal = vatTotal.FormatMoney().ToNumber() == taxInvoice.vatTotal.FormatMoney().ToNumber();
  const validateZeroVatTotal =
    zeroVatTotal.FormatMoney().ToNumber() == taxInvoice.zeroVatTotal.FormatMoney().ToNumber();

  let verifyType = VerifyType.Success;
  let verifyText: any = "";

  if (isDeleted) {
    verifyType = VerifyType.Fail;
    verifyText = i18n.t("Data_From_PEAK_Discontinued");
  } else if (
    validateDate &&
    validatNetAmount &&
    validateNumber &&
    validatePreVatTotal &&
    validateVatExemptedTotal &&
    validateVatTotal &&
    validateZeroVatTotal
  ) {
    verifyType = VerifyType.Success;
    verifyText = i18n.t("This_Item_Has_Been_Validated");
  } else {
    verifyType = VerifyType.Warn;
    verifyText = i18n.t("Data_From_PEAK_Has_Changed");
  }

  transaction.verifyType = verifyType;
  transaction.verifyText = verifyText;
}

export function CompareTaxInvoiceContact(transactionList: any, transaction: any, index: any) {
  let verifyContactType: any = VerifyType.Success;
  let verifyContactText: any = i18n.t("This_Item_Has_Been_Validated");
  const transactionMockupList = NewObject(transactionList);
  if (index > -1) {
    transactionMockupList.splice(index, 1);
  }
  const transactionMockupListMapContact = transactionMockupList.filter(
    (x: any) => x.contactId === transaction.contactId && x.taxInvoiceType === transaction.taxInvoiceType
  );
  if (transactionMockupListMapContact && transactionMockupListMapContact.length > 0) {
    const transactionDate = transaction.taxInvoiceDate ? transaction.taxInvoiceDate.ToDateJsonString() : "";
    const transactionMockupListMapDate = transactionMockupListMapContact.filter((x: any) => {
      const itemDate = x.taxInvoiceDate ? x.taxInvoiceDate.ToDateJsonString() : "";
      if (itemDate && transactionDate && itemDate === transactionDate) {
        return true;
      }
    });

    if (transactionMockupListMapDate && transactionMockupListMapDate.length > 0) {
      const transactionMockup = transactionMockupListMapDate.find(
        (x: any) =>
          x.vatExemptedTotal == transaction.vatExemptedTotal &&
          x.zeroVatTotal == transaction.zeroVatTotal &&
          x.preVatTotal == transaction.preVatTotal &&
          x.vatTotal == transaction.vatTotal
      );
      if (transactionMockup) {
        verifyContactType = VerifyType.Fail;
        verifyContactText = i18n.t("Have_Contact_Tax_Invoice_Issue_Date_And_Amount_Are_Same");
      } else {
        verifyContactType = VerifyType.Warn;
        verifyContactText = i18n.t("Have_Contact_Tax_Invoice_Issue_Date_Are_Same_But_Amount_Not_Same");
      }
    } else {
      const transactionMockup = transactionMockupListMapContact.find(
        (x: any) =>
          x.vatExemptedTotal == transaction.vatExemptedTotal &&
          x.zeroVatTotal == transaction.zeroVatTotal &&
          x.preVatTotal == transaction.preVatTotal &&
          x.vatTotal == transaction.vatTotal
      );

      if (transactionMockup) {
        verifyContactType = VerifyType.Warn;
        verifyContactText = i18n.t("Have_Contact_Tax_Invoice_Issue_Amount_Are_Same_But_Day_Issued");
      }
    }
  }

  transaction.verifyContactType = verifyContactType;
  transaction.verifyContactText = verifyContactText;
  return new Promise((resolve, reject) => {
    return setTimeout(() => {
      resolve(true);
    }, 0);
  });
}

export function CompareTaxInvoiceVAT(transaction: any) {
  let verifyVatType = VerifyType.Success;
  let verifyVatText: any = i18n.t("This_Item_Has_Been_Validated");
  let vatTotal = (transaction.preVatTotal * 7) / 100;
  vatTotal = vatTotal.toFixed(2).ToNumber();
  let diff = (vatTotal - transaction.vatTotal).ToAccountingRoundUp().ToNumber();
  diff = diff >= 0 ? diff : diff * -1;

  if (diff > 20) {
    verifyVatType = VerifyType.Fail;
    verifyVatText = i18n.t("Pre_VAT_More_than_20");
  } else if (diff < 20 && diff > 0.1) {
    verifyVatType = VerifyType.Warn;
    verifyVatText = i18n.t("Pre_VAT_More_than_1_But_More_Than_20");
  }

  transaction.verifyVatType = verifyVatType;
  transaction.verifyVatText = verifyVatText;
}

export async function VerifiedTaxInvoiceDetailListForTaxPP30(
  transaction: any,
  transactionList: any,
  taxInvoiceList: any,
  index: any
) {
  let taxInvoice: any;
  await CompareTaxInvoiceContact(transactionList, transaction, index);
  CompareTaxInvoiceVAT(transaction);
  if (taxInvoiceList && taxInvoiceList.length > 0) {
    taxInvoice = taxInvoiceList.find((x: any) => x.id === transaction.sourceId);
  }
  if (taxInvoice) {
    ComparetaxInvoiceDetailForPP30(transaction, taxInvoice);
  } else {
    transaction.verifyType = VerifyType.Success;
    transaction.verifyText = i18n.t("This_Item_Has_Been_Validated");
  }

  return new Promise((resolve, reject) => {
    return setTimeout(() => {
      resolve(true);
    }, 0);
  });
}

export function GetVerifyType(taxInvoiceDetail: any) {
  const verifyContactType = taxInvoiceDetail.verifyContactType;
  const verifyContactText = taxInvoiceDetail.verifyContactText;
  const verifyType = taxInvoiceDetail.verifyType;
  const verifyText = taxInvoiceDetail.verifyText;
  const verifyVatType = taxInvoiceDetail.verifyVatType;
  const verifyVatText = taxInvoiceDetail.verifyVatText;
  let className = "";
  const contentList: any = [];

  if (verifyContactType == VerifyType.Fail || verifyType == VerifyType.Fail || verifyVatType == VerifyType.Fail) {
    className = "fail";
  } else if (
    verifyContactType == VerifyType.Warn ||
    verifyType == VerifyType.Warn ||
    verifyVatType == VerifyType.Warn
  ) {
    className = "new-warn";
  } else if (
    verifyContactType == VerifyType.Success &&
    verifyType == VerifyType.Success &&
    verifyVatType == VerifyType.Success
  ) {
    className = "success";
    contentList.push(verifyContactText);
  }

  if (verifyType == VerifyType.Fail) {
    contentList.push(verifyText);
  }

  if (verifyContactType == VerifyType.Fail) {
    contentList.push(verifyContactText);
  }

  if (verifyVatType == VerifyType.Fail) {
    contentList.push(verifyVatText);
  }

  if (verifyType == VerifyType.Warn) {
    contentList.push(verifyText);
  }

  if (verifyContactType == VerifyType.Warn) {
    contentList.push(verifyContactText);
  }

  if (verifyVatType == VerifyType.Warn) {
    contentList.push(verifyVatText);
  }

  return { className: className, contentList: contentList };
}

export function GetPP30TransactionStatus(transactionStatus: TransactionStatus) {
  let statusName: any = "";
  let className = "";

  switch (transactionStatus) {
    case TransactionStatus.NotFiledTax:
      statusName = i18n.t("Table_Tap_NotFiled");
      className = "statusNotFiledTax";
      break;
    case TransactionStatus.AwaitFiling:
      statusName = i18n.t("Table_Tap_AwaitFiling");
      className = "statusAwaitFiling";
      break;
    case TransactionStatus.FiledTax:
      statusName = i18n.t("Table_Tap_FiledTax");
      className = "statusFiledTax";
      break;
  }

  return { name: statusName, class: className };
}

export function GetPP30TransactionStatusForTable(transactionStatus: TransactionStatus, taxPeriod: any) {
  let statusName: any = "";
  let className = "";

  switch (transactionStatus) {
    case TransactionStatus.NotFiledTax:
      statusName = i18n.t("Table_Tap_NotFiled");
      className = "statusNotFiledTax";
      break;
    case TransactionStatus.AwaitFiling:
      statusName = taxPeriod
        ? i18n.t("Await_Period", { taxPeriod: GetTaxPeriodText(taxPeriod) })
        : i18n.t("Table_Tap_AwaitFiling");
      className = "statusAwaitFiling";
      break;
    case TransactionStatus.FiledTax:
      statusName = taxPeriod
        ? i18n.t("Filed_Period", { taxPeriod: GetTaxPeriodText(taxPeriod) })
        : i18n.t("Table_Tap_FiledTax");
      className = "statusFiledTax";
      break;
  }

  return { name: statusName, class: className };
}

export function GetTaxPeriodText(taxPeriod: any) {
  let text = "";

  if (taxPeriod) {
    const period = new Date(taxPeriod);
    const month = period.getMonth() + 1;
    const monthText = month >= 10 ? month : "0" + month;
    text = `${monthText}/${period.getFullYear()}`;
  }
  return text;
}

export function GetPP30FormStatus(pp30FormStatus: PP30FormStatus) {
  let statusName: any = "";
  let className = "";

  switch (pp30FormStatus) {
    case PP30FormStatus.Draft:
      statusName = i18n.t("Table_Tap_Draft");
      className = "statusDraft";
      break;
    case PP30FormStatus.AwaitApproval:
      statusName = i18n.t("Table_Tap_AwaitApprove");
      className = "statusAwaitApproval";
      break;
    case PP30FormStatus.AwaitFiling:
      statusName = i18n.t("Table_Tap_AwaitFiling");
      className = "statusAwaitFiling";
      break;
    case PP30FormStatus.Filed:
      statusName = i18n.t("Table_Tap_FiledTax");
      className = "statusFiledTax";
      break;
  }
  return { name: statusName, class: className };
}

export function GetPP30FormPeriodYearStatus(pp30FormStatus: PP30FormStatus) {
  let statusName: any = "";
  let className = "";

  switch (pp30FormStatus) {
    case PP30FormStatus.Draft:
      statusName = i18n.t("Table_Tap_Draft");
      className = "statusDraft";
      break;
    case PP30FormStatus.AwaitApproval:
      statusName = i18n.t("Table_Tap_AwaitApprove");
      className = "statusAwaitApproval";
      break;
    case PP30FormStatus.AwaitFiling:
      statusName = i18n.t("Detail_AwaitFiling");
      className = "statusDetailAwaitFiling";
      break;
    case PP30FormStatus.Filed:
      statusName = i18n.t("Table_Tap_FiledTax");
      className = "statusFiledTax";
      break;
    case PP30FormStatus.AwaitPayment:
      statusName = i18n.t("Detail_AwaitPayment");
      className = "statusDetailAwaitPayment";
      break;
    case PP30FormStatus.AwaitReceipt:
      statusName = i18n.t("Detail_AwaitReceipt");
      className = "statusDetailAwaitReceipt";
      break;
    case PP30FormStatus.GotReceipt:
      statusName = i18n.t("Detail_GotReceipt");
      className = "statusDetailGotReceipt";
      break;
  }
  return { name: statusName, class: className };
}

export function GetTaxInvoiceTypeName(taxInvoiceType: TaxInvoiceType, financeType: FinanceType) {
  let name: any = "";
  switch (taxInvoiceType) {
    case TaxInvoiceType.TaxInvoice:
      if (financeType === FinanceType.InFlow) {
        name = i18n.t("Tax_Invoice_Sales");
      } else {
        name = i18n.t("Tax_Invoice_Purchase");
      }
      break;
    case TaxInvoiceType.DebitNote:
      if (financeType === FinanceType.InFlow) {
        name = i18n.t("Debit_Note_Sales");
      } else {
        name = i18n.t("Debit_Note_Purchase");
      }
      break;
    case TaxInvoiceType.CreditNote:
      if (financeType === FinanceType.InFlow) {
        name = i18n.t("Credit_Note_Sales");
      } else {
        name = i18n.t("Credit_Note_Purchase");
      }
      break;
    case TaxInvoiceType.NonTaxInvoice:
      name = i18n.t("Non_Tax_Invoice");
      break;
  }
  return name;
}
